import base from './base';

export default {
  ...base,
  captchaSiteKey: '6Lc5l3QfAAAAAPYfu1DrHm1mU70xdJcaXpw-2G2v'
};
